/**
 * Application state management
 */
import { PHOTO_SHAPES } from "./constants.js";

export class AppState {
	constructor() {
		this.photoStage = null;
		this.photoLayer = null;
		this.frameLayer = null;
		this.photoImageNode = null;
		this.cropShapeNode = null;
		this.cropTransformer = null;
		this.originalPhotoSrc = null;
		this.activeDecorNode = null;
		this.activeTextNode = null;
		this.activeElementNode = null;
		this.photoInitialScale = 1;
		this.textIdCounter = 1;
		this.currentProductId = null;
		this.customMonumentTitle = null;
		this.cropShapeType = PHOTO_SHAPES.OVAL;
		this.selectedNodes = [];
		this.activeGroupNode = null;

		// Initialize photo state array
		if (!window.mcPhotoState) {
			window.mcPhotoState = [];
		}
	}

	incrementTextId() {
		return this.textIdCounter++;
	}

	setActiveText(node) {
		this.activeTextNode = node;
	}

	setActiveDecor(node) {
		this.activeDecorNode = node;
	}

	setActiveElement(node) {
		this.activeElementNode = node;
	}

	setActiveGroup(node) {
		this.activeGroupNode = node;
	}

	setSelectedNodes(nodes) {
		this.selectedNodes = Array.isArray(nodes) ? nodes : [];
	}

	getSelectedNodes() {
		return Array.isArray(this.selectedNodes) ? this.selectedNodes : [];
	}

	clearActiveElements() {
		this.activeTextNode = null;
		this.activeDecorNode = null;
		this.activeElementNode = null;
		this.activeGroupNode = null;
		this.setSelectedNodes([]);
	}
}

export const appState = new AppState();
